import { render, staticRenderFns } from "./AppPageOptionBox.vue?vue&type=template&id=6e0c1480&scoped=true&"
import script from "./AppPageOptionBox.vue?vue&type=script&lang=js&"
export * from "./AppPageOptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c1480",
  null
  
)

export default component.exports